import { store } from '@editor2/store';
import { showToast } from '@editor2/reducers/toastSlice';
import { ToastSeverity } from '@editor2/types/toastSeverity';

export const showErrorToast = (message: string) => {
	store.dispatch(showToast({ severity: ToastSeverity.Error, message }));
};
